import {
    STATUS_APPROVED, STATUS_APPROVED_WITH_APPLYING, STATUS_APPROVED_WITH_REJECTED,
} from "@/constants/audit";
import {
    getDegreeName,
    getExperienceName, getJobValue,
    salaryMultipleName,
    salaryName
} from "~/utils/job";
import {
    cityName2,
    countyName2,
    provinceName
} from "~/utils/area";
import CompanySsr from "@/models/company-ssr";
import JdLink from "@/models/jd-link";
import {getJdStatusName} from "@/utils/jd";
import {fen2KYuan, fen2Yuan} from "@/utils/money";

const DESC = "职位描述： \n1. 职位描述1 \n2. 职位描述2 \n... \n\n"
    + "任职要求： \n1. 要求描述1 \n2. 要求描述2 \n... \n\n"
    + "其他可选说明： \n1. 其他说明1 \n2. 其他说明2 \n... \n\n"

export default class JdSsr {

    constructor(options) {
        this._id = options?._id || 0

        this.createdAt = options?.createdAt || ""
        this.updatedAt = options?.updatedAt || ""
        this.userId = options?.userId || 0
        this.companyId = options?.companyId || 0
        this.jobCatId = options?.jobCatId || 0
        this.jobSubCatId = options?.jobSubCatId || 0
        this.jobId = options?.jobId || 0
        this.job = options?.job || getJobValue(this.jobCatId,this.jobSubCatId,this.jobId)
        this.experienceId = options?.experienceId || 0
        this.degreeId = options?.degreeId || 0
        this.salaryId = options?.salaryId || 0
        this.salaryFrom = options?.salaryFrom || 0
        this.salaryTo = options?.salaryTo || 0
        this.salaryMultiple = options?.salaryMultiple || 0.0
        this.title = options?.title || ""
        this.keyWords = options?.keyWords || ""
        this.welfares = options?.welfares || ""
        this.desc = options?.desc || DESC
        this.provinceId = options?.provinceId || 0
        this.cityId = options?.cityId || 0
        this.countyId = options?.countyId || 0
        this.address = options?.address || ""

        this.statusId = options?.statusId || 0
        this.statusText = options?.statusText || "-"
        this.auditExtra = options?.auditExtra || ""

        this.company = new CompanySsr(options?.company)

        this.isNew = this._id <= 0
        //this.statusShort = jdStatusShort(this.statusId)
        this.statusShort = getJdStatusName(this.statusId)
        this.isApproved = this.statusId == STATUS_APPROVED
            // || this.statusId == STATUS_APPROVED_WITH_APPLYING
            // || this.statusId == STATUS_APPROVED_WITH_REJECTED

        this.companyNickName = this.company.nickName
        this.companyFullName = this.company.fullName
        this.companyLogoUrl = this.company.logoUrl
        this.industryName = this.company.industryName
        this.industryName2 = this.company.industryName2
        this.industryName3 = this.company.industryName3
        this.industryNames = this.company.industryNames
        this.scaleName = this.company.scaleName
        this.stageName = this.company.stageName
        this.experienceName = "经验"+getExperienceName(this.experienceId)
        this.degreeName = getDegreeName(this.degreeId)
        this.salaryName = salaryName(options?.salaryId || 0,options?.salaryTo || 0)
        this.salaryFromName = fen2KYuan(this.salaryFrom)
        this.salaryToName = fen2KYuan(this.salaryTo)
        this.salaryMultipleName = salaryMultipleName(this.salaryMultiple)
        this.salaryRange = this.salaryFromName +"-"+ this.salaryToName +" * "+ this.salaryMultipleName
        this.provinceName = provinceName(this.provinceId)
        this.cityName = cityName2(this.provinceId, this.cityId)
        this.countyName = countyName2(this.provinceId, this.cityId, this.countyId)

        this.cvReviewPrice = options?.cvReviewPrice || 0
        this.itvPrice = options?.itvPrice || 0
        this.itvCvReviewPrice = options?.itvCvReviewPrice || 0
        this.careerPlanningPrice = options?.careerPlanningPrice || 0
        this.cvReviewPriceName = fen2Yuan(this.cvReviewPrice)
        this.itvPriceName = fen2Yuan(this.itvPrice)
        this.itvCvReviewPriceName = fen2Yuan(this.itvCvReviewPrice)
        this.careerPlanningPriceName = fen2Yuan(this.careerPlanningPrice)

        this.jdLinks = []
        let links = options?.jdLinks
        if (links && links.length > 0) {
            for (let i = 0; i < links.length; i++) {
                let link = links[i]
                this.jdLinks.push(new JdLink(link))
            }
        }
    }

    toJSON() {
        return {...this}
    }
}
